import React,{useState,useEffect} from 'react'
import { Typography,
    Input ,
    Button,
    List,
    message,
    Popconfirm
} from 'antd';
import {
    CheckCircleTwoTone
} from '@ant-design/icons'
import {useSelector,useDispatch} from 'react-redux'
import {ReactComponent as ReferLogo} from './refer.svg'
import Fade from 'react-reveal'

export default function Refer() {
    const { Text,Paragraph } = Typography;
    const user = useSelector(state=>state.user);
    const [referal,setReferal] = useState("")
    const dispatch = useDispatch()
    const submitHandler =  ()=>{
        console.log(referal)
        if(referal!="" && referal.length>0){
            const payload = {
                by:referal,
                my:user.uid
            }
            dispatch({type:"REFER_REQUEST",payload})
        }else{
            message.error("Please Enter refer code")
        }
    }
    return (
        <Fade>
        <div id="refer-container">
        <h1 style={{color:"#40a9ff"}}>Refer and Earn</h1>
        <ReferLogo/>
            <br/>
            {user.refferedBy!=""?
           <p>Referred By: {user.refferedBy}  <CheckCircleTwoTone twoToneColor="#52c41a" /></p>
            :
            <div style={{flex:1,flexDirection:'column',display:'flex',justifyContent:'space-around',alignItems:'center'}}>
           
            <Input type="text" required placeholder="Enter your Referral Code" onChange={(e)=>setReferal(e.target.value)}/><br/>
          
            <Popconfirm placement="topLeft" title="Confirm the refer code" onConfirm={()=>submitHandler()} okText="Yes" cancelText="No">
            <Button >Submit</Button>
            </Popconfirm>
              
           
            </div>
        }
            
            <Paragraph style={{marginTop:'70px'}}>Refer your friends and both will get 500 coins 
            as Rewards, Share the below code to you friend
            </Paragraph>
            <Text copyable>{user.uid}</Text>

            <br/>
            <List
            size="large"
            style={{width:"80%"}}
            header={<div>Your Referrals</div>}
            footer={null}
            bordered
            dataSource={user.referrals}
            renderItem={item => <List.Item>{item}</List.Item>}
          />
        </div></Fade>
    )
}
